<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Analytics
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Reported Websites</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-flag me-1" style="color: #00A0C1;"></i>
                  Websites reported by users across your organisation.
               </small>
            </div>
         </div>
      </div>

      <ReportedWebsites />
   </div>
</template>

<script>
import ReportedWebsites from '@/components/Analytics/Reported Websites/ReportedWebsites2.vue';

export default {
   components: {
      ReportedWebsites,
   },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>